import { ArrowRight } from "lucide-react";
import { AlluLogo } from "./AlluLogo";
import { CTAAnchor } from "./cta";

export const ParceirosHeader = () => {
  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur bg-[#FAF8F5]/85 border-b border-zinc-200">
      <div className="container-wide flex items-center justify-between py-4">
        <a href="/parceiros" aria-label="Allu" className="block">
          <AlluLogo
            variant="dark"
            className="h-10 sm:h-12 md:h-14 w-auto"
          />
        </a>

        <CTAAnchor href="#form" variant="primary" size="md" className="text-sm">
          Quero ser parceiro
          <ArrowRight className="w-4 h-4" />
        </CTAAnchor>
      </div>
    </header>
  );
};
